// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"535":"a3754c703812f741","768":"ede3292f61a15a6f"}[chunkId] + ".js";
};